import { useHistory } from 'react-router-dom';
import { Container, Button, Col, Row } from 'reactstrap';

interface LocationState {
  is_team_member?: boolean;
}

export const CreatePasswordConfirmation = ({}: any) => {
  const history = useHistory<LocationState>();
  
  const Confirmation = () => {
    return (
      <div className='py-5 text-center'>
        <h3 className='mb-5'>Profile Created</h3>
        <p>
          Congrats! You have successfully created a profile with Help Hope Live.
          Click or tap the button to go to your dashboard.
        </p>
        <Button
          className='mb-3'
          color='primary'
          onClick={() => history.push('/dashboard')}
        >
          Go to Dashboard
        </Button>
      </div>
    );
  };

  return (
    <Container>
      <Row className='justify-content-center py-5'>
        <Col md='6'>
          <Confirmation />
        </Col>
      </Row>
    </Container>
  );
};
